module.exports = __webpack_public_path__ + "img/130.8b281a73.jpg";